import React from 'react';
import { Div, Text } from '@pezeshk-book/ui-kit';
import TaxiIcon from '@icons-components/taxi-icon';
import BusIcon from '@icons-components/bus-icon';
import MetroIcon from '@icons-components/metro-icon';
import ParkingIcon from '@icons-components/parking-icon';
import ElevatorIcon from '@icons-components/elevator-icon';
import LocationOutlineIcon from '@icons-components/location-outline-icon';
import Button from '@elements/button';

const DoctorAccordionDetails = ({ userContacts, translate }: any) => {
  return (
    <Div className={'w-full flex-col p-2 md:p-10 gap-8'}>
      {userContacts && userContacts.length > 0 ? userContacts.map((item: any) => {
        return (
          <Div key={`user_contact_${item.id}`} className={'flex-col gap-2'}>
            {item?.latitude && item?.longitude ? (
              <Div className={'items-center gap-2'}>
                <Button
                  href={`https://maps.google.com?q=${parseFloat(item?.latitude).toFixed(5)},${parseFloat(item?.longitude).toFixed(5)}`}
                  target={'_blank'}
                  rel="noreferrer"
                  startAdornment={<LocationOutlineIcon/>}
                  size={'small'}
                  className={'gap-1 items-center'}
                  variant={'outlined'}
                  color={'control'}>
                  {translate.location}
                </Button>
              </Div>
            ) : null}
            <Div className={'grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3'}>
              <Div className={'gap-1 items-center'}>
                <Div className={'w-4 h-4 items-center justify-center relative text-tertiary'}>
                  <MetroIcon/>
                </Div>
                <Text color={'grey.900'} typography={'sm'}>
                  {translate.metro}
                </Text>
                <Text align={'start'} color={'grey.700'} typography={'sm'}>{item?.location_subway || translate.empty}</Text>
              </Div>
              <Div className={'gap-1 items-center'}>
                <Div className={'w-4 h-4 items-center justify-center relative text-tertiary'}>
                  <BusIcon/>
                </Div>
                <Text color={'grey.900'} typography={'sm'}>
                  {translate.bus}
                </Text>
                <Text align={'start'} color={'grey.700'} typography={'sm'}>{item?.location_bus || translate.empty}</Text>
              </Div>
              <Div className={'gap-1 items-center'}>
                <Div className={'w-5 h-5 items-center justify-center relative text-tertiary'}>
                  <TaxiIcon/>
                </Div>
                <Text color={'grey.900'} typography={'sm'}>
                  {translate.taxi}
                </Text>
                <Text className={'overflow-hidden whitespace-nowrap text-ellipsis'} align={'start'} color={'grey.700'} typography={'sm'}>{item?.location_taxi || translate.empty}</Text>
              </Div>
              <Div className={'gap-1 items-center'}>
                <Div className={'w-5 h-5 items-center justify-center relative text-tertiary'}>
                  <ParkingIcon/>
                </Div>
                <Text color={'grey.900'} typography={'sm'}>
                  {translate.parking}
                </Text>
                <Text align={'start'} color={'grey.700'} typography={'sm'}>{item?.location_parking || translate.empty}</Text>
              </Div>
              <Div className={'gap-1 items-center'}>
                <Div className={'w-4 h-4 items-center justify-center relative text-tertiary'}>
                  <ElevatorIcon/>
                </Div>
                <Text color={'grey.900'} typography={'sm'}>
                  {translate.elevator}
                </Text>
                <Text align={'start'} color={'grey.700'} typography={'sm'}>{item?.has_elevator || translate.empty}</Text>
              </Div>
            </Div>
          </Div>
        );
      }) : (
        <Div>
          <Text color={'grey.600'} type={'bold'} typography={'base'}>
            {translate.no_address}
          </Text>
        </Div>
      )}
    </Div>
  );
};

export default DoctorAccordionDetails;
